import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import { checkModifiedBy } from '../../function'
import { FONTS, COLORS } from '../../constants'

export default class CustomTableStandardPrice extends React.Component {
  constructor(props) {
    super(props)
    this.state = { id: '' }
    this.handleClickRow = this.handleClickRow.bind(this)
  }
  handleClickRow(e, edit_id, id) {
    this.props.handleClickEdit(id)
    this.setState({ id: edit_id })
  }

  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              { get(this.props, 'header.length') !== 0 &&
              get(this.props, 'header').map((h, key) =>
                <HeadStd>{ h }</HeadStd>
              )}
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' } }>
            {
              get(this.props, 'data.length') !== 0 &&
          get(this.props, 'data').map((d, key) => {
            return (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && get(this.props, 'span')) ? '#E5E5E5' : '' } } onClick={ () => this.handleClickRow(this, key, d._id) }>
              <td>{ d.start_date ? moment(d.start_date).format('YYYY-MM-DD') : '' }</td>
              <td>{ d.level_code }</td>
              <td>{ d.name }</td>
              <td style={ { textAlign: 'right' } }>
                {
                  <NumberFormat
                    thousandSeparator={ true }
                    decimalScale={ 2 }
                    fixedDecimalScale={ true }
                    displayType='text'
                    value={ d.cost }
                  />
                }
              </td>
              <td style={ { textAlign: 'right' } }>
                {
                  <NumberFormat
                    thousandSeparator={ true }
                    decimalScale={ 2 }
                    fixedDecimalScale={ true }
                    displayType='text'
                    value={ d.price }
                  />
                }
              </td>
              <td>{ checkModifiedBy(d.updated_by, get(this.props, 'employeeList', [])) }</td>
            </tr>)
          }
          )}
          </tbody>
        </NewTable>
      </Wrapper>
    )
  }
}

CustomTableStandardPrice.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const HeadStd = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`




// WEBPACK FOOTER //
// ./src/components/table-standard-price/index.js